var map = {
	"./au.svg": 91575,
	"./be.svg": 14042,
	"./br.svg": 33155,
	"./ca.svg": 36685,
	"./ch.svg": 76437,
	"./de.svg": 36747,
	"./fi.svg": 64150,
	"./gb.svg": 45816,
	"./hk.svg": 29310,
	"./id.svg": 12608,
	"./nl.svg": 92116,
	"./sg.svg": 76610,
	"./us.svg": 18688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8096;